import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=5ab624fc&"
import script from "./callback.vue?vue&type=script&lang=js&"
export * from "./callback.vue?vue&type=script&lang=js&"
import style0 from "./callback.vue?vue&type=style&index=0&id=5ab624fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports